/**
 * Copyright 2016-2021 Sourcepole AG
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree.
 */

import {REGISTER_FILTERS, SET_LEVELFILTER, SET_LAYERFILTERS} from '../actions/layersext';
import layersReducer from "qwc2/reducers/layers";
import RepositoryUtils from "../utils/RepositoryUtils";

// Start from the base reducer's initial state (flat, loading, swipe, filter, editConfigs, ...)
const defaultState = {
    ...layersReducer(undefined, {type: '@@layersext/INIT'}),
    levelFilter: 0,
    filters: []
};

export default function layers(state = defaultState, action) {
    switch (action.type) {
        case REGISTER_FILTERS: {
            return {...state, filters: action.filters};
        }
        case SET_LAYERFILTERS: {
            const newLayers = (state.flat || []).map((layer) => {
                const filtered = RepositoryUtils.applyFiltersToLayer(layer, state.levelFilter, action.filters);
                return {...filtered, filterLevel: state.levelFilter, layerFilters: action.filters};
            });

            return {...state, flat: newLayers, filters: [...action.filters]};
        }
        case SET_LEVELFILTER: {
            const newLayers = (state.flat || []).map((layer) => {
                const filtered = RepositoryUtils.applyFiltersToLayer(layer, action.levelFilter, state.filters);
                return {...filtered, filterLevel: action.levelFilter, layerFilters: state.filters};
            });

            return {...state, flat: newLayers, levelFilter: parseInt(action.levelFilter)};
        }
        default:
            return layersReducer(state, action);
    }
}
